var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _g, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExpired(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 409,
    viewBox: "0 0 400 409",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M194.925 337.577C282.345 337.577 353.217 266.704 353.217 178.972C353.217 91.2395 282.345 20.3672 194.925 20.3672C107.505 20.3672 36.6328 91.2395 36.6328 178.972C36.6328 266.704 107.505 337.577 194.925 337.577Z",
    fill: "#EAEEF9"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M371.325 113.715C378.397 113.715 384.126 107.984 384.126 100.914C384.126 93.8443 378.397 88.1133 371.325 88.1133C364.257 88.1133 358.524 93.8443 358.524 100.914C358.524 107.984 364.257 113.715 371.325 113.715Z",
    fill: "#EAEEF9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M390.057 63.4488C394.887 63.4488 398.799 59.5349 398.799 54.7068C398.799 49.8788 394.887 45.9648 390.057 45.9648C385.231 45.9648 381.315 49.8788 381.315 54.7068C381.315 59.5349 385.231 63.4488 390.057 63.4488Z",
    fill: "#EAEEF9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.0174 122.769C30.8455 122.769 34.7594 118.855 34.7594 114.027C34.7594 109.199 30.8455 105.285 26.0174 105.285C21.1893 105.285 17.2754 109.199 17.2754 114.027C17.2754 118.855 21.1893 122.769 26.0174 122.769Z",
    fill: "#EAEEF9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M42.2519 312.916C51.218 312.916 58.487 305.647 58.487 296.68C58.487 287.714 51.218 280.445 42.2519 280.445C33.2854 280.445 26.0166 287.714 26.0166 296.68C26.0166 305.647 33.2854 312.916 42.2519 312.916Z",
    fill: "#EAEEF9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M207.42 36.9531H181.225V54.0022H207.42V36.9531Z",
    fill: "#D1D9E7"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M108.129 70.9062L93.9141 85.1142L104.252 95.4472L118.468 81.2393L108.129 70.9062Z",
    fill: "#D5DDEA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M274.357 80.1982L288.573 94.4065L297.834 85.1496L283.619 70.9414L274.357 80.1982Z",
    fill: "#D5DDEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M204.072 307.598C273.717 307.598 330.177 251.167 330.177 181.557C330.177 111.946 273.717 55.5156 204.072 55.5156C134.426 55.5156 77.9678 111.946 77.9678 181.557C77.9678 251.167 134.426 307.598 204.072 307.598Z",
    fill: "#D5DDEA"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_7703_54631)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M196.456 303.039C266.101 303.039 322.56 246.609 322.56 176.998C322.56 107.388 266.101 50.957 196.456 50.957C126.81 50.957 70.3516 107.388 70.3516 176.998C70.3516 246.609 126.81 303.039 196.456 303.039Z",
    fill: "url(#paint0_linear_7703_54631)"
  }))), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M85.2767 183.995C82.2308 183.995 79.7939 181.559 79.7939 178.514C79.7939 177.905 79.7939 177.297 79.7939 176.992C79.7939 118.234 123.656 68.6091 181.834 61.3024C184.881 60.998 187.622 63.1288 187.927 66.1735C188.231 69.2179 186.099 71.9579 183.053 72.2623C130.357 78.9602 90.7595 124.018 90.7595 176.992C90.7595 177.601 90.7595 177.905 90.7595 178.514C90.7595 181.559 88.3227 183.995 85.2767 183.995Z",
    fill: "white"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M294.841 177C294.841 178.218 294.841 179.132 294.841 180.35C293.013 233.019 249.76 275.337 196.456 275.337C143.151 275.337 99.8977 233.019 98.0703 180.35C98.0703 179.132 98.0703 178.218 98.0703 177C98.0703 124.027 140.105 80.4908 192.8 78.6641C194.019 78.6641 195.237 78.6641 196.456 78.6641C250.37 78.6641 293.927 121.896 294.841 175.174C294.841 175.783 294.841 176.392 294.841 177Z",
    fill: "#CCD5E3"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M294.841 180.349C293.013 233.018 249.76 275.336 196.456 275.336C143.151 275.336 99.8977 233.018 98.0703 180.349C99.8977 127.679 143.151 85.361 196.456 85.361C249.76 85.0566 293.013 127.375 294.841 180.349Z",
    fill: "white"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M281.743 181.863H265.599C262.858 181.863 260.726 179.732 260.726 176.992C260.726 174.252 262.858 172.121 265.599 172.121H281.743C284.484 172.121 286.617 174.252 286.617 176.992C286.617 179.732 284.18 181.863 281.743 181.863Z",
    fill: "#CBD4E2"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M122.438 181.863H106.295C103.553 181.863 101.421 179.732 101.421 176.992C101.421 174.252 103.553 172.121 106.295 172.121H122.438C125.179 172.121 127.312 174.252 127.312 176.992C127.312 179.732 124.875 181.863 122.438 181.863Z",
    fill: "#CBD4E2"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M194.019 269.855C191.278 269.855 189.146 267.724 189.146 264.984V248.848C189.146 246.108 191.278 243.977 194.019 243.977C196.761 243.977 198.893 246.108 198.893 248.848V264.984C198.588 267.724 196.456 269.855 194.019 269.855Z",
    fill: "#CBD4E2"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M194.019 110.628C191.278 110.628 189.146 108.497 189.146 105.757V89.9258C189.146 87.1859 191.278 85.0547 194.019 85.0547C196.761 85.0547 198.893 87.1859 198.893 89.9258V106.062C198.588 108.497 196.456 110.628 194.019 110.628Z",
    fill: "#CBD4E2"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M195.238 190.395C203.481 190.395 210.163 183.715 210.163 175.476C210.163 167.238 203.481 160.559 195.238 160.559C186.995 160.559 180.312 167.238 180.312 175.476C180.312 183.715 186.995 190.395 195.238 190.395Z",
    fill: "#F2F5FC"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M276.301 182.564C276.202 180.339 274.474 178.441 272.46 178.347L200.884 176.801C200.692 176.59 200.692 176.59 200.499 176.379C198.003 173.638 193.975 173.449 191.236 175.944C191.025 176.136 190.814 176.328 190.604 176.52L179.115 176.182C176.891 176.28 174.994 178.007 174.9 180.021C174.844 181.229 175.21 182.054 175.978 182.897C176.746 183.741 177.724 184.392 178.741 184.238L190.229 184.576C190.421 184.787 190.613 184.997 190.613 184.997C193.11 187.739 197.137 187.928 199.877 185.433C200.088 185.241 200.298 185.049 200.509 184.857L271.875 186.594C274.502 186.516 276.399 184.789 276.301 182.564Z",
    fill: "#DAE1ED"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M276.121 177.712C276.022 175.487 274.294 173.59 272.28 173.495L200.704 171.95C200.512 171.739 200.512 171.739 200.32 171.528C197.823 168.787 193.796 168.598 191.056 171.093C190.845 171.285 190.635 171.477 190.424 171.669L178.935 171.331C176.711 171.428 174.814 173.156 174.72 175.169C174.664 176.378 175.03 177.202 175.798 178.046C176.566 178.889 177.545 179.54 178.561 179.387L190.05 179.724C190.242 179.935 190.434 180.146 190.434 180.146C192.93 182.887 196.958 183.076 199.697 180.581C199.908 180.389 200.119 180.197 200.329 180.005L271.695 181.743C274.323 181.664 276.027 179.726 276.121 177.712Z",
    fill: "url(#paint1_linear_7703_54631)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M219.909 12.8974V29.3375C219.909 35.7308 214.731 40.6019 208.639 40.6019H180.616C174.219 40.6019 169.346 35.4264 169.346 29.3375V12.8974C169.346 6.50397 174.524 1.63281 180.616 1.63281H208.639C215.035 1.63281 219.909 6.80841 219.909 12.8974Z",
    fill: "url(#paint2_linear_7703_54631)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    d: "M219.909 12.8974V29.3375C219.909 35.7308 214.731 40.6019 208.639 40.6019H180.616C174.219 40.6019 169.346 35.4264 169.346 29.3375V26.293C171.173 34.2087 178.179 34.2087 178.179 34.2087H207.116C211.076 34.2087 214.426 30.8597 214.426 26.9019V15.0285C214.426 6.80841 212.903 3.76396 208.639 1.63281C215.035 1.63281 219.909 6.80841 219.909 12.8974Z",
    fill: "#495A7C"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M173.61 31.1663C172.696 31.1663 172.087 30.5574 172.087 29.6441V10.7684C172.087 9.855 172.696 9.24609 173.61 9.24609C174.524 9.24609 175.133 9.855 175.133 10.7684V29.6441C174.828 30.5574 174.219 31.1663 173.61 31.1663Z",
    fill: "#AEB8C9"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M180.616 31.1663C179.702 31.1663 179.093 30.5574 179.093 29.6441V10.7684C179.093 9.855 179.702 9.24609 180.616 9.24609C181.53 9.24609 182.139 9.855 182.139 10.7684V29.6441C182.139 30.5574 181.53 31.1663 180.616 31.1663Z",
    fill: "#AEB8C9"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M187.927 31.1663C187.013 31.1663 186.404 30.5574 186.404 29.6441V10.7684C186.404 9.855 187.013 9.24609 187.927 9.24609C188.841 9.24609 189.45 9.855 189.45 10.7684V29.6441C189.146 30.5574 188.536 31.1663 187.927 31.1663Z",
    fill: "#AEB8C9"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M194.934 31.1663C194.02 31.1663 193.411 30.5574 193.411 29.6441V10.7684C193.411 9.855 194.02 9.24609 194.934 9.24609C195.848 9.24609 196.457 9.855 196.457 10.7684V29.6441C196.457 30.5574 195.848 31.1663 194.934 31.1663Z",
    fill: "#AEB8C9"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M202.243 31.1663C201.329 31.1663 200.72 30.5574 200.72 29.6441V10.7684C200.72 9.855 201.329 9.24609 202.243 9.24609C203.157 9.24609 203.766 9.855 203.766 10.7684V29.6441C203.461 30.5574 202.852 31.1663 202.243 31.1663Z",
    fill: "#AEB8C9"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M209.249 31.1663C208.335 31.1663 207.726 30.5574 207.726 29.6441V10.7684C207.726 9.855 208.335 9.24609 209.249 9.24609C210.162 9.24609 210.772 9.855 210.772 10.7684V29.6441C210.772 30.5574 209.858 31.1663 209.249 31.1663Z",
    fill: "#AEB8C9"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    d: "M216.255 31.1663C215.342 31.1663 214.732 30.5574 214.732 29.6441V10.7684C214.732 9.855 215.342 9.24609 216.255 9.24609C217.169 9.24609 217.778 9.855 217.778 10.7684V29.6441C217.778 30.5574 217.169 31.1663 216.255 31.1663Z",
    fill: "#AEB8C9"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M110.865 72.2646L95.6348 87.4869C92.2841 90.8357 86.8014 90.8357 83.1463 87.4869L74.3128 78.6578C70.9621 75.309 70.9621 69.8291 74.3128 66.1755L89.5429 50.9532C92.8933 47.6041 98.3761 47.6041 102.031 50.9532L110.865 59.782C114.215 63.4356 114.215 68.9155 110.865 72.2646Z",
    fill: "url(#paint3_linear_7703_54631)"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M280.828 72.2646L296.058 87.4869C299.409 90.8357 304.892 90.8357 308.547 87.4869L317.38 78.6578C320.73 75.309 320.73 69.8291 317.38 66.1755L302.15 50.9532C298.8 47.6041 293.317 47.6041 289.662 50.9532L280.828 59.782C277.478 63.4356 277.478 68.9155 280.828 72.2646Z",
    fill: "url(#paint4_linear_7703_54631)"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M194.629 176.713C195.054 177.179 195.775 177.213 196.241 176.789C196.707 176.365 196.741 175.643 196.316 175.177C195.892 174.712 195.171 174.678 194.705 175.102C194.239 175.526 194.205 176.248 194.629 176.713Z",
    fill: "white"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M160.339 163.192C165.42 163.192 169.718 158.893 169.718 153.813C169.718 148.732 165.42 144.434 160.339 144.434C155.259 144.434 150.96 148.732 150.96 153.813C150.96 158.893 155.259 163.192 160.339 163.192Z",
    fill: "#989FB0"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M232.246 163.192C237.327 163.192 241.626 158.893 241.626 153.813C241.626 148.732 237.327 144.434 232.246 144.434C227.166 144.434 222.867 148.732 222.867 153.813C222.867 159.284 227.166 163.192 232.246 163.192Z",
    fill: "#989FB0"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M159.973 122.789L139.341 133.929L142.126 139.087L162.758 127.947L159.973 122.789Z",
    fill: "#989FB0"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M230.972 122.641L228.188 127.799L248.822 138.937L251.606 133.779L230.972 122.641Z",
    fill: "#989FB0"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M209.525 206.938H181.426V213.182H209.525V206.938Z",
    fill: "#989FB0"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_7703_54631",
    x: 1.66454,
    y: 16.6135,
    width: 389.583,
    height: 389.456,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 34.3435
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 34.3435
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.397708 0 0 0 0 0.47749 0 0 0 0 0.575 0 0 0 0.27 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_7703_54631"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_7703_54631",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_7703_54631",
    x1: 196.373,
    y1: 45.1261,
    x2: 196.373,
    y2: 305.757,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDFEFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9964,
    stopColor: "#ECF0F5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_7703_54631",
    x1: 251.394,
    y1: 152.868,
    x2: 220.077,
    y2: 181.389,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_7703_54631",
    x1: 194.631,
    y1: 2.98656,
    x2: 194.631,
    y2: 24.8596,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_7703_54631",
    x1: 92.592,
    y1: 49.8852,
    x2: 92.592,
    y2: 73.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint4_linear_7703_54631",
    x1: 299.108,
    y1: 49.8852,
    x2: 299.108,
    y2: 73.2106,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B0BACC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#969EAE"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExpired);
export default __webpack_public_path__ + "static/media/Expired.68f40d0ed013ef22ce9e530dae8b4a24.svg";
export { ForwardRef as ReactComponent };